import React from "react";

// product card component
const ProductCard = ({ description, productName, image ,webLink}) => {
  return (
    <div className="flex flex-col relative bg-white shadow-shadow4 rounded-xl px-4 py-5 ml-2 lg:ml-4 h-full">
      {/* product image */}
      <img src={image} alt="marks" className="h-44 md:h-64 object-scale-down" />

      <div className="p-5">
        {/* product name */}
        <span className="text-gray1 text-normal font-normal font-montserrat">
          Product Name: {productName}
        </span>

        {/* product description */}
        <p className="text-blue-8 text-sm font-normal font-montserrat mb-14 mt-5">
          {description}
        </p>

        {/* know more text */}
        <a
         href={webLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="absolute bottom-4 right-4 text-blue7 font-inter font-medium text-xs md:text-base cursor-pointer hover:text-blue5">
            know more
          </span>
        </a>
      </div>
    </div>
  );
};

export default ProductCard;
